// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selector .full-width {
  width: 100%;
}
.item-selector .selector-container {
  max-height: 300px;
  overflow-y: auto;
}
.item-selector .search-input {
  width: 100%;
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.item-selector .custom-option {
  height: auto !important;
  padding: 8px 16px !important;
}
.item-selector .option-group {
  font-style: italic;
  color: gray;
}
.item-selector .selected-summary {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selector/item-selector.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAGE;EACE,iBAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,2CAAA;EACA,sBAAA;AAFJ;AAKE;EACE,uBAAA;EACA,4BAAA;AAHJ;AAME;EACE,kBAAA;EACA,WAAA;AAJJ;AAOE;EACE,eAAA;AALJ","sourcesContent":[".item-selector {\n  .full-width {\n    width: 100%;\n  }\n\n  .selector-container {\n    max-height: 300px;\n    overflow-y: auto;\n  }\n\n  .search-input {\n    width: 100%;\n    padding: 12px;\n    border-bottom: 1px solid rgba(0,0,0,0.1);\n    box-sizing: border-box;\n  }\n\n  .custom-option {\n    height: auto !important;\n    padding: 8px 16px !important;\n  }\n\n  .option-group {\n    font-style: italic;\n    color: gray;\n  }\n\n  .selected-summary {\n    margin-top: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
